import React from 'react'
import ButtonPanel from '../../../../../ButtonPanel'
import Button from '../../../../../Button'
import './index.scss'
import { isEmpty } from 'lodash'

const Avatar = (props) => {
  const { getAvatar, actions, user } = props
  const renderAvatarSection = () => {
    return (
      <>
        {/* <div className='avatar-header'></div> */}
        <div className='avatar-body'>
          <div className='avatar-body-primary'>
            <h5>{user.name || user.sub}</h5>
            <h6>{user.roles}</h6>
          </div>
          <div className='avatar-body-secondary'>
            {isEmpty(user.email) ? '\u00A0' : <h6>{user.email}</h6>}
          </div>
        </div>

        <div className='avatar-footer'>
          {actions.map(({ title, onClick, kind }, index) => {
            return (
              <Button kind={kind || 'primary'} key={index} onClick={onClick}>
                {title}
              </Button>
            )
          })}
        </div>
      </>
    )
  }

  return (
    <ButtonPanel
      panelClassname='ublique-avatar-panel '
      iconComponent={getAvatar}
      contentComponent={renderAvatarSection()}
      id='BDD_user_area_button'
    />
  )
}
export default Avatar
